// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

// This was generated using spacetimedb cli version 1.3.0 (commit ).

/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import {
  AlgebraicType,
  AlgebraicValue,
  BinaryReader,
  BinaryWriter,
  ConnectionId,
  DbConnectionBuilder,
  DbConnectionImpl,
  Identity,
  ProductType,
  ProductTypeElement,
  SubscriptionBuilderImpl,
  SumType,
  SumTypeVariant,
  TableCache,
  TimeDuration,
  Timestamp,
  deepEqual,
  type CallReducerFlags,
  type DbContext,
  type ErrorContextInterface,
  type Event,
  type EventContextInterface,
  type ReducerEventContextInterface,
  type SubscriptionEventContextInterface,
} from "@clockworklabs/spacetimedb-sdk";

import { Point as __Point } from "./point_type";

export type AddCharacter = {
  tabletop: number,
  name: string,
  friendly: boolean,
  sprite: string,
  size: number,
  position: __Point | undefined,
  initMod: number | undefined,
};

/**
 * A namespace for generated helper functions.
 */
export namespace AddCharacter {
  /**
  * A function which returns this type represented as an AlgebraicType.
  * This function is derived from the AlgebraicType used to generate this type.
  */
  export function getTypeScriptAlgebraicType(): AlgebraicType {
    return AlgebraicType.createProductType([
      new ProductTypeElement("tabletop", AlgebraicType.createU32Type()),
      new ProductTypeElement("name", AlgebraicType.createStringType()),
      new ProductTypeElement("friendly", AlgebraicType.createBoolType()),
      new ProductTypeElement("sprite", AlgebraicType.createStringType()),
      new ProductTypeElement("size", AlgebraicType.createU32Type()),
      new ProductTypeElement("position", AlgebraicType.createOptionType(__Point.getTypeScriptAlgebraicType())),
      new ProductTypeElement("initMod", AlgebraicType.createOptionType(AlgebraicType.createI32Type())),
    ]);
  }

  export function serialize(writer: BinaryWriter, value: AddCharacter): void {
    AddCharacter.getTypeScriptAlgebraicType().serialize(writer, value);
  }

  export function deserialize(reader: BinaryReader): AddCharacter {
    return AddCharacter.getTypeScriptAlgebraicType().deserialize(reader);
  }

}

